import React, {useState, useEffect} from 'react';
import { useStoreState } from 'easy-peasy'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import '../../assets/layout/header.css';
import continentalFinanceLogo from '../../assets/layout/continental-finance-logo.png';
import marketing from '../../services/marketing';
import { tcGenerator } from '../../services/tcGenerator';
import ErrorModal from '../body/forms/components/ErrorModal'
import LoadingModal from '../body/forms/components/LoadingModal';
import { useHistory } from 'react-router-dom';
import { FLOW, PRODUCT } from '../../models/websiteTypesConstants';

function Header() {

    const mainSettings = useStoreState(state => state.siteSettingsModel.mainSettings);
    const applicant = useStoreState(state => state.applicantModel.applicant)    
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const routingSettings = useStoreState(state => state.routingSettingsModel.routingSettings);
    const assetsLink = useStoreState(state => state.assetsImageLink);
    const utm = new marketing();
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);
    const [pCode, setPCode] = useState(mainSettings.ProductCode);
    const [errorShow, setErrorShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const closeError = () => setErrorShow(false);
    const [loading, setLoading] = useState(false);
    const info = useStoreState((state) => state.applicantModel.applicant);
    const history = useHistory();

    const handleViewTerms = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const { fileContent, hasErrors, errorMessage } = await tcGenerator(pCode);
            setLoading(false);
            if (hasErrors) {
                setErrorMessage(errorMessage);
                setErrorShow(true);
                return;
            }
            const byteCharacters = atob(fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            const blobUrl = URL.createObjectURL(blob);

            window.open(blobUrl, "_blank");
        } catch (err) {
            setLoading(false)
            setErrorMessage(`${err.message}`);
            setErrorShow(true);
        }
    };

    const handleRetry = () => {
        setErrorShow(false);
        handleViewTerms();
      };
    
    const defaultPrivacyUrl = useStoreState(state => state.siteSettingsModel.defaultPrivacyUrl); 

    useEffect(() => {
        if (applicant.ProductCode || applicant.ProductCode !== "") {  
            localStorage.setItem("TCProductCode", applicant.product_code)
            setPCode(applicant.ProductCode);
        }

    }, [applicant.ProductCode])

    useEffect(() => {
        if (applicationResult.product_code || (typeof applicationResult.product_code !== 'undefined' && mainSettings.Flow !== "STANDALONE" && mainSettings.Flow !== "DM") || applicationResult.product_code !== "" || applicationResult.alternate_product_code === null) {
            localStorage.setItem("TCProductCode", applicationResult.product_code)
            setPCode(applicationResult.product_code);
        }

    }, [applicationResult.product_code])

    useEffect(() => {
        if (applicationResult.alternate_product_code && applicationResult.alternate_product_code !== "" && applicationResult.alternate_product_code !== null) {
            localStorage.setItem("TCProductCode", applicationResult.alternate_product_code)
            setPCode(applicationResult.alternate_product_code);
        }
       
    }, [applicationResult.alternate_product_code])

    useEffect(() => {
        if(!routingSettings.TermsHeaderCDN){
            localStorage.setItem("TCProductCode", pCode)
        }
    },[routingSettings.TermsHeaderCDN])

    return (
        <div>
            <LoadingModal show={loading} message="Loading Terms & Conditions..." />
            <ErrorModal size='sm' show={errorShow} message={errorMessage} closeError={closeError} onRetry={handleRetry} />
            <div className="header-container container d-none d-lg-block">
                <img id="product-logo" style={{ width : (mainSettings.Flow === FLOW.CFC) ? "200px" : (brandSettings.ProductName === PRODUCT.Grand.bank ? "300px" : "233px")}} alt="" src={brandSettings.HeaderLogo}></img>
                <ul>
                    {routingSettings.PrivacyHeader ?
                        <li id="li-privacy" className="header-text" style={{ fontSize : (mainSettings.Flow === FLOW.CFC) ? "13px" : ""}}>
                            <a onClick={ () => { utm.updateSessionReport("privacyLink") }} href={brandSettings.ProductName === PRODUCT.Grand.bank ? productSettings.PrivacyUrl : defaultPrivacyUrl} target="_blank" rel="noopener noreferrer">PRIVACY</a>
                        </li> : null
                    }
                    {routingSettings.CashBackRewardsHeader ?
                        <li className="header-text" style={{ fontSize : (mainSettings.Flow === FLOW.CFC) ? "13px" : ""}}>
                            <a href={productSettings.CashBackRewardsUrl} target="_blank" rel="noopener noreferrer">CASH BACK REWARDS AGREEMENT</a>
                        </li> : null
                    }
                    <li id="li-masterCard">
                        <img alt="" src="https://images.continentalfinance.net/applicationweb/Common/mastercard-logo.svg"></img>
                    </li>
                    
                    <li id="li-secure-site" className="header-text" style={{ fontSize : (mainSettings.Flow === FLOW.CFC) ? "13px" : ""}}>
                        <FontAwesomeIcon icon={faLock} /> &nbsp;
                        THIS IS A SECURE SITE
                    </li>
                    {(mainSettings.Flow === FLOW.DM || mainSettings.Flow === FLOW.CS) ?
                        routingSettings.TermsHeader &&
                            <li id="li-terms" className="header-text">
                                {
                                    (window.location.href.split('/').at(-1) === '' || (info.IsRollUpCode && routingSettings.TermsHeaderCDN)) ? <a href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer">TERMS</a> :
                                    (info.IsRollUpCode && ['/terms', '/decision', '/pendinfo'].some(p => window.location.href.includes(p))) ? <a href='/tc' target="_blank" className="button-link" onClick={() => {utm.updateSessionReport("termsLink"); localStorage.setItem("TCProductCode", info.ProductCode)}} >TERMS</a> :
                                    <a href="#" onClick={(e) => { e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsButton"); localStorage.setItem("TCProductCode", pCode)}} target="_blank" rel="noopener noreferrer">TERMS</a>
                                }
                            </li>
                    :
                        routingSettings.TermsHeader &&
                            <li id="li-terms" className="header-text">
                                {routingSettings.TermsHeaderCDN ? <a href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer">TERMS</a> :
                                <a href="#" onClick={(e) => { e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsButton"); localStorage.setItem("TCProductCode", pCode)}} target="_blank" rel="noopener noreferrer">TERMS</a>}
                            </li>
                    }
                    
                </ul>
            </div>
            <div className={mainSettings.Flow === FLOW.CFC ? "header-container container d-none d-md-block d-lg-none" : "header-container container d-lg-none sm"} >
                <div className="row justify-content-between">
                    <div className="col-6 linkText">
                        <img style={{height : (brandSettings.ProductName === PRODUCT.Revel) ? "inherit" : ""}} id="product-logo-sm" alt="" src={brandSettings.HeaderLogo} className="my-2 productLogoSm"/>
                        <div><FontAwesomeIcon icon={faLock} /> THIS IS A SECURE SITE</div>
                    </div>
                    <div className="col-auto">
                        <img alt="" src="https://images.continentalfinance.net/applicationweb/Common/mastercard-logo.svg" className="mastercardImg my-2"/> 
                        <div className={brandSettings.ProductName === PRODUCT.Revel ? "row align-items-end mx-1" : "row mx-1"}>
                            {routingSettings.PrivacyHeader ?
                                <div className="col-auto linkText px-1">
                                    <a href={brandSettings.ProductName === PRODUCT.Grand.bank ? productSettings.PrivacyUrl : defaultPrivacyUrl} target="_blank" rel="noopener noreferrer">PRIVACY</a>
                                </div> : null
                            }
                            {routingSettings.CashBackRewardsHeader ?
                                <div className="col-auto linkText px-1">
                                    <a href={productSettings.CashBackRewardsUrl} target="_blank" rel="noopener noreferrer">CASH BACK REWARDS AGREEMENT</a>
                                </div> : null
                            }
                            {(mainSettings.Flow === FLOW.DM || mainSettings.Flow === FLOW.CS) ?
                            routingSettings.TermsHeader &&
                                <div className="col-auto linkText px-1">
                                     {
                                        (info.IsRollUpCode && routingSettings.TermsHeaderCDN) ? <a href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer">TERMS</a> :
                                        (info.IsRollUpCode && ['/terms', '/decision', '/pendinfo'].some(p => window.location.href.includes(p))) ? <a href='/tc' target="_blank" className="button-link" onClick={() => {utm.updateSessionReport("termsLink"); localStorage.setItem("TCProductCode", info.ProductCode)}} >TERMS</a> :
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsButton"); localStorage.setItem("TCProductCode", pCode)}} target="_blank" rel="noopener noreferrer">TERMS</a>
                                    }
                                </div> :
                                routingSettings.TermsHeader &&
                                <div className="col-auto linkText px-1">
                                    {routingSettings.TermsHeaderCDN ? <a href={productSettings.TermsUrl} target="_blank" rel="noopener noreferrer">TERMS</a> :
                                    <a href="#" onClick={(e) => { e.preventDefault(); handleViewTerms(); utm.updateSessionReport("termsButton"); localStorage.setItem("TCProductCode", pCode)}} target="_blank" rel="noopener noreferrer">TERMS</a>}
                                </div>
                            }
                             {/* eslint-enable jsx-a11y/anchor-is-valid */}
                        </div>
                    </div>
                </div>
            </div>
            {mainSettings.Flow === FLOW.CFC ?
                <div className="header-container container d-block d-md-none">
                    <div className="row justify-content-between">
                        <div className="col-6 linkText">
                            <img style={{height : (brandSettings.ProductName === PRODUCT.Revel) ? "inherit" : ""}} id="product-logo-sm" alt="" src={brandSettings.HeaderLogo} className="my-2 mx-1 productLogoSm"/>
                            <div className="mx-1"><FontAwesomeIcon icon={faLock} /> THIS IS A SECURE SITE</div>
                        </div>
                        <div className="col-6 linkText">
                            <div className="row mr-2 justify-content-end" >
                                <img alt="" src="https://images.continentalfinance.net/applicationweb/Common/mastercard-logo.svg" className="mastercardImgMobile my-2"/>
                            </div>
                            <div className="row mr-2 justify-content-end" >
                                {routingSettings.PrivacyHeader ?
                                        <a href={brandSettings.ProductName === PRODUCT.Grand.bank ? productSettings.PrivacyUrl : defaultPrivacyUrl} target="_blank" rel="noopener noreferrer">PRIVACY</a>
                                    : null
                                }
                            </div>
                            {routingSettings.CashBackRewardsHeader ? 
                                <div className="row mr-2 justify-content-end">
                                    <a href={productSettings.CashBackRewardsUrl} target="_blank" rel="noopener noreferrer" className="text-right">CASH BACK REWARDS AGREEMENT</a>
                                </div>
                            : null }
                        </div>
                    </div>
                </div>
            : null }
        </div>
    )
}

export default Header;